import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { IWebMenu } from '../interfaces/webMenu'
import {
  equalToOneOfTheUrls,
  findMenuItem,
  getSlug,
  getUrlObjectByParentList,
  partOfOneOfTheUrls,
  urlObjectFactoryForWebmenus,
} from '../utils/webmenus'

const useActiveWebmenu = (webmenus: { [key: string]: IWebMenu }): any => {
  const [webmenu, setWebmenu] = useState<IWebMenu | null | undefined>(undefined)
  const router = useRouter()
  const { pathname, asPath, query } = router

  useEffect(() => {
    const path = asPath.substring(0, asPath.indexOf('?') !== -1 ? asPath.indexOf('?') : asPath.length); 
    if (query?.webmenuId && typeof query.webmenuId === 'string') {
      const { webmenuId } = query
      setWebmenu(webmenus[webmenuId])
    } else if (pathname !== path) {
      setWebmenu(findMenuItem(webmenus, path))
    } else if (pathname === '/') {
      setWebmenu(webmenus['HOME'])
    } 
  }, [asPath, pathname, query, webmenus])

  useEffect(() => {
    const path = asPath.substring(0, asPath.indexOf('?') !== -1 ? asPath.indexOf('?') : asPath.length); 
    const isPreview = asPath.includes('preview=1');
 
    if (webmenu && pathname !== path) {
      if (equalToOneOfTheUrls(path, webmenu)) {
        const { urlObject } = urlObjectFactoryForWebmenus(webmenu)
        router.replace(urlObject, asPath, { shallow: true })
      } else if (partOfOneOfTheUrls(path, webmenu)) {
        const urlObject = getUrlObjectByParentList(
          webmenu.type,
          path,
          webmenu.id,
          isPreview
        )

        router.replace(urlObject, asPath, { shallow: true })
      } else {
        router.replace({ pathname: '/article', query: { contentId: getSlug(path) }}, asPath, { shallow: true })
      }
    } else if (path !== '/' && Object.keys(webmenus).length && webmenu === webmenus['HOME']) {
      router.replace({ pathname: '/article', query: { contentId: getSlug(path) }}, asPath, { shallow: true })
    } else {
    }
  }, [webmenu])
  return webmenu
}

export default useActiveWebmenu
